import { useEffect, useState, useContext } from 'react'
import { Helmet } from "react-helmet";
import { useNavigate } from 'react-router-dom';
import { fetchWithAuth } from "./Utils"
import { Account } from "./Main"
import "./Gestione.css"

const Gestione = () => {
    const [user_state, setUserState] = useState("");
    const [utenti, setUtenti] = useState([]);
    const [filtro, setFiltro] = useState("");
    const { showAlert } = useContext(Account);
    const nav = useNavigate();

    useEffect(() => {
        document.body.scrollTop = 0;

        const check_user = async () => {
            let resp = await fetchWithAuth("check_user_state.php");
            setUserState(resp.stato);
        }
        check_user();
    }, []);

    useEffect(() => {
        if (user_state == "maestro") {
            scaricaUtenti();
        } else if (user_state != "") {
            nav("/"); // redirect se non autorizzato
        }
    }, [user_state]);

    const scaricaUtenti = async () => {
        const data = await fetchWithAuth("visualizza_utenti.php", {}, "GET");
        let ordinati = data.utenti.sort((a, b) => (a.username > b.username ? 1 : -1));
        ordinati = ordinati.filter((user) => user.username != "aaaaa" && user.username != "ospite.ospite");
        setUtenti(ordinati);
    };

    const handleChange = (username, field, value) => {
        const nuoviUtenti = utenti.map((utente) => {
            if (utente.username === username) {
                return { ...utente, [field]: value };
            }
            return utente;
        });
        setUtenti(nuoviUtenti);
    };

    const modificaUtente = async (username) => {
        let utente_list = utenti.filter((x) => x.username == username);
        let utente;
        if (utente_list.length > 0)
            utente = utente_list[0];
        try {
            const resp = await fetchWithAuth("modifica_utente.php", {
                method: "POST",
                body: JSON.stringify({
                    usernameModifica: utente.username,
                    socio: parseInt(utente.socio),
                    maestro: parseInt(utente.maestro),
                    scadenza_cert: utente.scadenza_cert
                })
            });
            if (resp.ok) {
                showAlert("Successo!", "Dati aggiornati con successo");
            }
        } catch (error) {
            showAlert("Attenzione!", error.message);
        }
    };

    const eliminaUtente = async (username) => {
        if (!window.confirm("Sei sicuro di voler eliminare " + username + "?")) return;

        const utente = utenti.find(u => u.username === username);
        if (!utente) return;

        try {
            const resp = await fetchWithAuth("elimina_utente.php", {
                method: "POST",
                body: JSON.stringify({
                    username: utente.username
                })
            });

            if (resp.ok) {
                showAlert("Successo!", "Utente eliminato con successo!");
                setUtenti(utenti.filter(u => u.username !== username));
            }
        } catch (error) {
            showAlert("Attenzione!", error.message);
        }
    };



    return (
        <>
            <Helmet>
                <title>Sporting - Gestione utenti</title>
                <meta
                    name="description"
                    content="Pagina di gestione utenti per Maestri."
                />
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>
            <div className="search-bar">
                <input
                    type="text"
                    placeholder="Cerca username..."
                    value={filtro}
                    onChange={(e) => setFiltro(e.target.value)}
                    className="search-input"
                />
            </div>

            <div className="gestione-container">
                {
                    utenti
                        .filter(u => u.username.toLowerCase().includes(filtro.toLowerCase()))
                        .map((elemento) => (
                            <div key={elemento.username} className="user-card">

                                <span className="user-username"><i className="fa-solid fa-user" style={{ marginRight: 20 }}></i>{elemento.username}</span>
                                <span className="user-username">Email: {elemento.email}</span>

                                <div className="user-role-group">
                                    <label className="user-role-label">Scadenza del certificato:</label>
                                    <input type="date" value={elemento.scadenza_cert} onChange={(e) => handleChange(elemento.username, "scadenza_cert", e.target.value)} />
                                </div>

                                <div className="user-role-group">
                                    <label className="user-role-label">Socio:</label>
                                    <select
                                        className="user-role-select"
                                        value={elemento.socio ? "1" : "0"}
                                        onChange={(e) => handleChange(elemento.username, "socio", parseInt(e.target.value))}
                                    >
                                        <option value="0">No</option>
                                        <option value="1">Sì</option>
                                    </select>
                                </div>

                                <div className="user-role-group">
                                    <label className="user-role-label">Maestro:</label>
                                    <select
                                        className="user-role-select"
                                        value={elemento.maestro ? "1" : "0"}
                                        onChange={(e) => handleChange(elemento.username, "maestro", parseInt(e.target.value))}
                                    >
                                        <option value="0">No</option>
                                        <option value="1">Sì</option>
                                    </select>
                                </div>

                                <div style={{ display: "flex", justifyContent: "space-evenly", gap: "20px" }}>
                                    <input
                                        type="button"
                                        className="user-role-button delete"
                                        value="Elimina"
                                        onClick={() => eliminaUtente(elemento.username)}
                                    />
                                    <input
                                        type="button"
                                        className="user-role-button"
                                        value="Modifica"
                                        onClick={() => modificaUtente(elemento.username)}
                                    />
                                </div>
                            </div>
                        ))
                }
            </div>
        </>
    );
}

export default Gestione;
